export default function Line({content}){
  return <>
    <span style={{display:'block'}}>{(content) ? content : <>&nbsp;</>}</span>
  </>
}